module.exports = __webpack_public_path__ + "static/media/logo.bde6d060.png";